module.exports = __webpack_public_path__ + "img/mh.9f6d50e1.svg";